import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            追剧心声
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            追剧爱好者们的真实体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}